import { render } from "./UserAgreement.vue?vue&type=template&id=0d237135&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"

import "./UserAgreement.vue?vue&type=style&index=0&id=0d237135&scoped=true&lang=css"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d237135"]])

export default __exports__